import React from "react";

import { AccountActivityReviewReportDto } from "@api-types/reports/ReportResultDto";
import { WalletIcon } from "@components/icons/WalletIcon";
import { getDisplayedAmount } from "@utils";
import classNames from "classnames";

export default function AccountStatementPaymentTableItem(props: {
	tableItem: AccountActivityReviewReportDto;
}) {
	if (!props.tableItem) {
		return null;
	}

	const depositClass = classNames(
		"table__body__cell table__cell table__cell--sml u-type--right u-type--wgt--medium",
		{
			"u-color--sent--danger": props.tableItem.Deposit < 0,
		}
	);

	const withdrawalClass = classNames(
		"table__body__cell table__cell table__cell--sml u-type--right u-type--wgt--medium",
		{
			"u-color--sent--success": props.tableItem.Withdrawal > 0,
		}
	);

	const gainClass = classNames(
		"table__body__cell table__cell table__cell--sml u-type--right u-type--wgt--medium",
		{
			"u-color--sent--success": props.tableItem.Gain > 0,
		}
	);

	const lossClass = classNames(
		"table__body__cell table__cell table__cell--sml u-type--right u-type--wgt--medium",
		{
			"u-color--sent--danger": props.tableItem.Loss != 0,
		}
	);

	return (
		<>
			<tr className="table__body__tr table__row">
				<td className="table__body__cell table__cell table__cell--sml table__cell--icon-only">
					<WalletIcon
						bettingAccountTypeAbrv={
							props.tableItem.BettingAccountTypeAbrv
						}
						marginReset
					/>
				</td>
				<td className="table__body__cell table__cell table__cell--sml u-color--text--primary">
					{props.tableItem.NumberOfTransactions}
				</td>
				<td className={depositClass}>
					{getDisplayedAmount(
						props.tableItem.Deposit,
						props.tableItem.DisplayCode
					)}
				</td>
				<td className={withdrawalClass}>
					{getDisplayedAmount(
						props.tableItem.Withdrawal,
						props.tableItem.DisplayCode
					)}
				</td>
				<td className={gainClass}>
					{getDisplayedAmount(
						props.tableItem.Gain,
						props.tableItem.DisplayCode
					)}
				</td>
				<td className={lossClass}>
					{getDisplayedAmount(
						props.tableItem.Loss,
						props.tableItem.DisplayCode
					)}
				</td>
			</tr>
		</>
	);
}
